import { render, staticRenderFns } from "./StorefrontIntegrationSystemSelect.vue?vue&type=template&id=37a89bb6"
import script from "./StorefrontIntegrationSystemSelect.vue?vue&type=script&lang=js"
export * from "./StorefrontIntegrationSystemSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports